import { useLocation } from "react-router-dom";
import { MessageCircle, Phone } from "lucide-react";
import { useApp } from "../context/AppContext";
import { track } from "../analytics";

const PAGE_MSG = {
  "/garvi": ["Garvi 2.0", "Garvi 2.0"],
  "/e-stamping": ["E-Stamping", "ઈ-સ્ટેમ્પિંગ"],
  "/rent-agreement": ["Rent Agreement", "ભાડા કરાર"],
  "/registration": ["document registration", "દસ્તાવેજ રજિસ્ટ્રેશન"],
  "/verification": ["property verification", "પ્રોપર્ટી વેરિફિકેશન"],
};

export function FloatingButtons() {
  const { site, lang } = useApp();
  const { pathname } = useLocation();
  const wa = site.whatsapp;
  const phone = site.phone;
  if (!wa && !phone) return null;
  const topic = PAGE_MSG[pathname] || (pathname.includes("garvi") ? ["Garvi 2.0", "Garvi 2.0"] : pathname.includes("stamp") ? ["E-Stamping", "ઈ-સ્ટેમ્પિંગ"] : pathname.includes("rent") ? ["Rent Agreement", "ભાડા કરાર"] : null);
  const msg = topic
    ? (lang === "gu" ? `નમસ્તે DocGalaxy, મને ${topic[1]} માટે સહાય જોઈએ છે.` : `Hi DocGalaxy, I need help with ${topic[0]}.`)
    : (lang === "gu" ? "નમસ્તે DocGalaxy, મને પ્રોપર્ટી દસ્તાવેજ માટે સહાય જોઈએ છે." : "Hi DocGalaxy, I need help with a property document.");
  return (
    <div className="fixed bottom-20 md:bottom-6 right-4 z-40 flex flex-col gap-3" data-testid="floating-buttons">
      {phone && (
        <a href={`tel:${phone}`} data-testid="floating-call-btn" aria-label="Call us" onClick={() => track("phone_click", { placement: "floating" })}
          className="w-12 h-12 rounded-full bg-primary text-white flex items-center justify-center shadow-lg hover:scale-105 transition-transform">
          <Phone size={20} />
        </a>
      )}
      {wa && (
        <a href={`https://wa.me/${wa}?text=${encodeURIComponent(msg)}`} onClick={() => track("whatsapp_click", { placement: "floating" })}
          target="_blank" rel="noopener noreferrer" data-testid="floating-whatsapp-btn" aria-label="WhatsApp us"
          className="w-12 h-12 rounded-full bg-green-500 text-white flex items-center justify-center shadow-lg hover:scale-105 transition-transform">
          <MessageCircle size={22} />
        </a>
      )}
    </div>
  );
}
